/* eslint-disable func-names */
import Vue from 'vue';
import Axios from 'axios';
import { Message } from 'element-ui';
import { sync } from 'vuex-router-sync';
// Optimize for tree shaking
import '@fortawesome/fontawesome-pro/css/all.css';

import App from './App.vue';
import router from './router';
import store from './store';

import './plugins/element';
import './style/main.scss';

Vue.config.productionTip = false;

// return data directly
const formatResponse = res => res.data;

// intercept errors and display error states
const intercept = function (err) {
  const { response } = err;
  return new Promise((() => {
    if (response && response.status === 422) {
      // handle expired JWT
      return Message.error({ duration: 6000, message: response.data.message });
    }
    if (response && response.status === 401) {
      // If jwt is bad, cache route to return after re-authenticating
      if (response.data === 'jwt expired' || response.data === 'invalid token') {
        Message.error({ duration: 5000, message: 'Session Expired. Please log in again' });
        // localStorage.setItem('lastPath', store.getters.routeData.path);
      } else {
        // Capture and display other auth errors
        Message.error({ duration: 5000, message: response.data.message });
      }
      // Clear expired auth data
      store.dispatch('LOGOUT');
    }
    throw err;
  }));
};

// Axios configuration
const token = localStorage.getItem('token');
if (token) {
  Axios.defaults.headers.common.Authorization = token;
}
Axios.interceptors.response.use(formatResponse, intercept);
Axios.defaults.baseURL = store.state.apiEndpoint;

// sync store & router
sync(store, router);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
